import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from "recharts";
import { ResultRow, CHART_COLORS } from "./constants";

interface DezenasTabProps {
  filtered: ResultRow[];
}

const DezenasTab: React.FC<DezenasTabProps> = ({ filtered }) => {
  const mostrarGrafico = false;
  const dezenaCount: Record<string, number> = {};
  filtered.forEach(r => {
    const dez = r.milhar.slice(-2);
    dezenaCount[dez] = (dezenaCount[dez] || 0) + 1;
  });

  const dezenaTop = Object.entries(dezenaCount)
    .map(([dez, count]) => ({ dezena: dez, count }))
    .sort((a, b) => b.count - a.count);

  const chartData = dezenaTop.slice(0, 10);
  const gridData = dezenaTop.slice(0, 20);

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg">Dezenas Mais Frequentes</CardTitle>
      </CardHeader>
      <CardContent className="space-y-6 px-2 sm:px-6">
        {/* Bar chart - Top 10 */}
        {mostrarGrafico && <div className="h-[250px] sm:h-[300px]">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={chartData} layout="vertical" margin={{ left: 40, right: 15 }}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis type="number" />
              <YAxis type="category" dataKey="dezena" width={40} tick={{ fontSize: 13, fontFamily: 'monospace' }} />
              <Tooltip />
              <Bar dataKey="count" name="Vezes" radius={[0, 4, 4, 0]}>
                {chartData.map((_, i) => (
                  <Cell key={i} fill={CHART_COLORS[i % CHART_COLORS.length]} />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>}

        {/* Grid - Top 20 */}
        <div className="grid grid-cols-2 sm:grid-cols-4 md:grid-cols-5 gap-3">
          {gridData.map((d) => (
            <div key={d.dezena} className="flex items-center justify-between p-3 rounded-lg border bg-card">
              <span className="font-mono font-bold text-lg">{d.dezena}</span>
              <span className="text-sm text-muted-foreground bg-muted px-2 py-1 rounded-full">
                {d.count}x
              </span>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default DezenasTab;
